import { Component, Input } from '@angular/core';

import { BibliographicResourceType } from './bibliographic-resource-types';

@Component({
  selector: 'rl-bibliographic-resource-type',
  templateUrl: './bibliographic-resource-type.component.html',
})
export class BibliographicResourceTypeComponent {
  @Input() resourceType: BibliographicResourceType;
  BibliographicResourceType = BibliographicResourceType;
}
